import React from "react";
import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

const WA_NUMBER = "918269784515"; // 91 = India country code
const WA_MSG = encodeURIComponent("Hi ASURE, I'm interested in your products. Please share details.");

export default function WhatsAppButton() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin") || loc.pathname === "/login") return null;
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed z-40 right-4 md:right-6 bottom-[76px] lg:bottom-6 group"
    >
      <span className="absolute -inset-1 rounded-full bg-[#25D366]/40 blur-md animate-pulse" aria-hidden="true" />
      <span className="relative flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-lg hover:shadow-xl transition-shadow">
        <span className="w-6 h-6 rounded-full bg-white/15 flex items-center justify-center"><MessageCircle size={16} className="fill-white text-white" /></span>
        <span className="hidden md:inline text-sm font-semibold tracking-wide">Chat on WhatsApp</span>
        <span className="md:hidden text-sm font-semibold">WhatsApp</span>
      </span>
    </a>
  );
}
